import { IGenericModelFields } from "./IGenericFields";

export enum UserExperienceState {
    /**
     * The experience has started (happening right now)
     */
    STARTED = "started",
    /**
     * The experience has completed (finished successfully)
     */
    COMPLETED = "completed",
    /**
     * The experience has been interrupted by another user experience
     */
    INTERRUPTED = "interrupted",
    /**
     * The experience has been abandoned (e.g. the user closed the browser or clicked back)
     */
    ABANDONED = "abandoned",
    /**
     * The experience has timed out, marked only automatically after a certain duration (set by MaxUserExperienceDurationsMinutes)
     */
    TIMED_OUT = "timedOut",
    /**
     * The experience has failed (e.g. the user encountered an error)
     */
    FAILED = "failed"
}

export enum UserExperienceType {
    CREATE_PRESENTATION = "createPresentation",
    ADD_SLIDES_TO_PRESENTATION = "addSlideToPresentation"
}

export const MaxUserExperienceDurationsMinutes: Record<UserExperienceType, number> = {
    [UserExperienceType.CREATE_PRESENTATION]: 20,
    [UserExperienceType.ADD_SLIDES_TO_PRESENTATION]: 10
};

export const UserExperienceSubtype = {
    [UserExperienceType.CREATE_PRESENTATION]: {
        CREATE_BLANK: "createBlank",
        GENERATE_WITH_AI: "generateWithAi",
        COPY_TEAM_TEMPLATE: "copyTeamTemplate",
        COPY_STARTER_TEMPLATE: "copyStarterTemplate",
        IMPORT_FROM_PPT: "importFromPpt"
    },
    [UserExperienceType.ADD_SLIDES_TO_PRESENTATION]: {
        ADD_FROM_TEMPLATE: "addFromTemplate",
        ADD_SHARED_SLIDES: "addSharedSlides",
        COPY_TEAM_TEMPLATES: "copyTeamTemplates",
        ADD_SHARED_SLIDES_AND_COPY_TEAM_TEMPLATES: "addSharedSlidesAndCopyTeamTemplates",
        COPY_GALLERY_SLIDES: "copyGallerySlides",
        COPY_EXISTING_SLIDES: "copyExistingSlides",
        GENERATE_WITH_AI: "generate-with-ai",
        IMPORT_FROM_PPT: "importFromPpt"
    }
};

interface IMetadata {
    sessionId: string;
    browserId: string;
    releaseVersion: string;
    uid?: string;
    workspaceId?: string;
    [key: string]: any;
}

export interface IUserExperience extends IGenericModelFields {
    type: UserExperienceType;
    state: UserExperienceState;
    stateModifiedAt: number;
    stateHistory: {
        state: UserExperienceState;
        timestamp: number;
    }[];
    metadata: IMetadata;
}
